import { useLocaleState, useRecordContext, useTranslate } from "react-admin";

import { formatDateTimeInline } from "../lib/dateUtils";
import { DeviceRecord } from "../types/device";
import { InfoFieldData, InfoPanel } from "./InfoPanel";

export const DeviceInfoPanel = () => {
  const record = useRecordContext<DeviceRecord>();
  const translate = useTranslate();
  const [locale] = useLocaleState();

  if (!record) return null;

  const sections: InfoFieldData[][] = [
    [
      { label: translate("deviceName"), value: record.name },
      { label: translate("deviceId"), value: record.deviceId },
      {
        label: translate("status"),
        value: record.unenrolledAt ? translate("deviceEnrollment.unenroll.status") : record.status,
      },
      ...(record.unenrolledAt
        ? [
            {
              label: translate("deviceEnrollment.unenroll.unenrolledAt"),
              value: formatDateTimeInline(record.unenrolledAt, locale),
            },
          ]
        : []),
    ],
    [
      { label: translate("manufacturer"), value: record.manufacturer },
      { label: translate("model"), value: record.model },
    ],
    [
      { label: translate("osVersion"), value: record.osVersion },
      { label: translate("appVersion"), value: record.appVersion },
      { label: translate("contentVersion"), value: record.contentVersion },
    ],
    [{ label: translate("location"), value: record.location?.name }],
  ];

  return <InfoPanel sections={sections} />;
};
